<loren-file-upload
  [allowedFileTypes]="allowedFileTypes"
  [fileSizeLimitInMb]="fileSizeLimitInMb"
  (fileSizeExceeded)="showFileSizeExceededError()"
  (fileTypeMismatch)="showFileTypeNotAllowedError($event)"
  (successfulFileUpload)="handleNewImageUpload($event)">
</loren-file-upload>
<div class="text-center">
  <img
    class="user-pic"
    [src]="userPic || '/assets/icons/user-256x256.png'"
    alt="profile-picture" />
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    class="upload-pic-area hover-pointer">
    <mat-icon class="upload-pic-icon">camera_alt</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="triggerFileSelection()">
      <mat-icon color="primary">upload_alt</mat-icon>
      <span>{{ "operations.avatar_change" | transloco }}</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="removePicture()">
      <mat-icon color="warn">delete_alt</mat-icon>
      <span>{{ "operations.delete" | transloco }}</span>
    </button>
  </mat-menu>
</div>
